import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class TextWrap extends BaseOption {
  static userInterfaceComponent = {
    label: "Text Wrap",
    component: inspectorTools.RADIO_BAR,
    props: {
      options: [
        {
          label: "Yes",
          value: "wrap",
          tooltip: "",
        },
        {
          label: "No",
          value: "nowrap",
          tooltip: "",
        },
      ],
    },
  };

  static defaultValue = "wrap";

  static convertConfigValueToCompiledValue(configValue) {
    return configValue === "wrap";
  }
}
